// A meeting tab can be shown for either a whole family or a single individual
// client. The shared meeting components are parameterised by this scope so the
// same implementation drives both the family screen and the individual screen.
export type MeetingScope =
  | { kind: 'family'; familyId: string }
  | { kind: 'individual'; clientId: string };

export function meetingsBasePath(scope: MeetingScope): string {
  return scope.kind === 'family'
    ? `/family/${scope.familyId}/meetings`
    : `/client/${scope.clientId}/meetings`;
}

export function meetingDetailPath(scope: MeetingScope, eventId: string): string {
  return scope.kind === 'family'
    ? `/family/${scope.familyId}/meeting/${eventId}`
    : `/client/${scope.clientId}/meeting/${eventId}`;
}
